import { Controller } from "stimulus";
import { useClickOutside } from "stimulus-use";
export default class extends Controller {
  static targets = [
    "productData",
    "productForm",
    "productID",
    "formButton",
    "quantity",
    "price",
    "gallery",
    "comparePrice",
    "sellingPlan",
    "selectElement",
    "subscriptionContainer",
    "subscriptionToggle",
    "subscriptionSelected",
    "subscriptionOptions",
  ];

  initialize() {
    console.log("Product controller initialized");
    if (this.hasProductDataTarget) {
      this.productData = JSON.parse(this.productDataTarget.innerText);
      this.handleVariantChange({ update: false });
      this.activeSellingPlan = this.hasSellingPlanTarget
        ? this.sellingPlanTarget.value
        : null;
    } else {
      return console.log("No product data found");
    }
  }

  connect() {
    if (this.hasSubscriptionToggleTarget) {
      useClickOutside(this, { element: this.subscriptionToggleTarget });
    }
  }

  clickOutside(e) {
    if (this.hasSubscriptionToggleTarget) {
      this.subscriptionToggle({ action: "hide" });
    }
  }

  subscriptionToggle({ action = undefined }) {
    if (
      this.subscriptionOptionsTarget.classList.contains(
        "product-subscription__options--active"
      ) ||
      action == "hide"
    ) {
      this.subscriptionOptionsTarget.classList.remove(
        "product-subscription__options--active"
      );
    } else {
      this.subscriptionOptionsTarget.classList.add(
        "product-subscription__options--active"
      );
    }
  }

  handleSellingPlanChange(e) {
    this.subscriptionToggle({ action: "hide" });

    this.subscriptionSelectedTarget.innerText = e.target.dataset.subscription;
    this.activeSellingPlan = e.target.dataset.id || null;
    this.updatePrice();
  }

  handleSellingGroupChange(e) {
    if (e.target.value === "nil") {
      this.subscriptionContainerTarget.classList.add(
        "product-subscription__container--hidden"
      );
      this.activeSellingPlan = null;
    } else {
      this.subscriptionContainerTarget.classList.remove(
        "product-subscription__container--hidden"
      );

      if (this.hasSubscriptionOptionsTarget) {
        this.activeSellingPlan =
          this.subscriptionOptionsTarget.firstElementChild?.dataset.id || null;
      }
    }

    this.updatePrice();
  }

  handleVariantChange({ update = true }) {
    if (this.hasProductFormTarget) {
      const data = new FormData(this.productFormTarget);

      const selectedOptions = [];
      let sellingPlan = {};
      data.forEach((value, key) => {
        if (key.includes("option")) {
          selectedOptions.push(value);
        }

        if (
          key === "bsub-selling-plan-group" ||
          key === "product-selling-plan"
        ) {
          sellingPlan = {
            ...sellingPlan,
            [key]: value,
          };
        }
      });

      this.selectedVariant =
        this.productData?.length > 1
          ? this.productData.find(
              (variant) => variant.options.join() === selectedOptions.join()
            )
          : this.productData[0];

      if (this.selectedVariant) {
        if (update) {
          this.productIDTarget.value = this.selectedVariant.id;
          this.updatePrice();
          this.updateGallery();
          this.formButtonTarget.classList.remove(
            "product-form__submit--disabled"
          );

          let priceToDisplay = this.selectedVariant.price;

          if (this.selectedVariant.available) {
            const subscriptionSelectorActive = document.querySelector(
              "#subscribe-options:checked"
            );

            if (
              this.selectedVariant.selling_plan_allocations?.length > 0 &&
              subscriptionSelectorActive
            ) {
              const newPrice =
                this.selectedVariant.selling_plan_allocations.find(
                  (allocation) => {
                    return (
                      allocation.selling_plan_id ==
                      sellingPlan["product-selling-plan"]
                    );
                  }
                ) || this.selectedVariant.selling_plan_allocations[0];
              priceToDisplay = newPrice.price;
            }
          } else {
          }
          const basePrice =
            this.formButtonTarget.querySelector("span:first-child");
          const comparePrice =
            this.formButtonTarget.querySelector("span:last-child");

          if (this.selectedVariant.available) {
            this.formButtonTarget.classList.remove(
              "product-form__submit--disabled"
            );

            basePrice.innerText =
              "Add to Cart - " + this.formatPrice(priceToDisplay / 100);
          } else {
            this.formButtonTarget.classList.add(
              "product-form__submit--disabled"
            );

            basePrice.innerText =
              "Sold Out - " + this.formatPrice(priceToDisplay / 100);
          }

          if (this.selectedVariant.compare_at_price) {
            comparePrice.classList.remove("hidden");
            comparePrice.innerHTML = `<s>${this.formatPrice(
              this.selectedVariant.compare_at_price / 100
            )}</s>`;
          } else {
            comparePrice.classList.add("hidden");
            comparePrice.innerHTML = "";
          }

          window.history.replaceState(
            null,
            null,
            `?variant=${this.selectedVariant.id}`
          );
        }
      } else {
        console.log("No variant found");
        const basePrice =
          this.formButtonTarget.querySelector("span:first-child");
        basePrice.innerText = "Combination Unavailable";

        this.formButtonTarget.classList.add("product-form__submit--disabled");
      }
    } else {
      console.log("No form found to select variant");
    }
  }

  formatPrice(price) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: document.querySelector("body").dataset.currencyCode,
    }).format(price);
  }

  increaseQuantity(e) {
    this.quantityTarget.value = parseInt(this.quantityTarget.value) + 1;

    this.productFormTarget
      .querySelector(".product-form__quantity--decrease")
      .removeAttribute("disabled", true);
  }

  decreaseQuantity(e) {
    if (this.quantityTarget.value > 1) {
      this.quantityTarget.value = parseInt(this.quantityTarget.value) - 1;

      if (this.quantityTarget.value == 1) {
        e.currentTarget.setAttribute("disabled", true);
      }
    }
  }

  updateGallery() {
    if (!this.hasGalleryTarget)
      return console.log("cannot update image, no gallery detected");

    const image = this.selectedVariant?.featured_image;
    if (image) {
      const thumbs = this.galleryTarget.querySelector(
        '[data-product-carousel-target="thumbs"]'
      );

      const targetImage = thumbs?.querySelector(`img[data-id="${image.id}"]`);

      targetImage?.click();
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    const item = {
      id: this.selectedVariant.id,
      quantity: this.quantityTarget.value,
    };

    if (this.activeSellingPlan) {
      item.selling_plan = parseInt(this.activeSellingPlan);
    }

    const items = [item];
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.description);
      } else {
        await this.quickCartController.getCartData();
      }
    } catch (error) {
      console.log("There was an error...", error);
    }
  }

  updatePrice() {
    const sellingPlan = this.selectedVariant.selling_plan_allocations.find(
      (allocation) => {
        return allocation.selling_plan_id == this.activeSellingPlan;
      }
    );

    const price = sellingPlan ? sellingPlan.price : this.selectedVariant.price;
    const basePrice = this.formButtonTarget.querySelector("span:first-child");

    console.log({ sellingPlan, price });
    if (this.selectedVariant.available) {
      basePrice.innerHTML = "Add to Cart - " + this.formatPrice(price / 100);
    } else {
      basePrice.innerHTML = "Unavailable";
    }

    if (this.hasPriceTarget) {
      this.priceTargets.forEach((priceTarget) => {
        if (priceTarget.dataset.discount) {
          priceTarget.innerText = this.formatPrice(
            (this.selectedVariant.price * priceTarget.dataset.discount) / 100
          );

          if (this.hasComparePriceTarget) {
            this.comparePriceTarget.innerText = this.formatPrice(
              this.selectedVariant.price / 100
            );
          }
        } else {
          priceTarget.innerText = this.formatPrice(
            this.selectedVariant.price / 100
          );
        }
      });
    }
  }

  get quickCartController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "quick-cart";
    });
  }
}
